import './actifsplus.scss';
import {default as initQuestionnaire} from "./pages/questionnaire";
import setUpResponsive from './js/responsive';
document.addEventListener("DOMContentLoaded", () => {
    setUpResponsive();
    initQuestionnaire(); 
});
